import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { DomainContextService } from './domain-context.service';

/**
 * The authenticationGuard checks if the user is authenticated.
 * If the user isn't authenticated, a redirect will happen to the sign in page.
 */
export const authenticationGuard: CanActivateFn = async (_, state): Promise<boolean | UrlTree> => {
  const authService = inject(AuthenticationService);
  const domainContextService = inject(DomainContextService);
  const router = inject(Router);

  if (await authService.isSignedIn()) {
    return true;
  }

  const signInRoute = domainContextService.isFleetsDomain() ? '/email-sign-in' : '/sign-in';

  return router.createUrlTree([signInRoute], {
    queryParams: { returnUrl: state.url },
  });
};
